<div class="">

<div class="error-template ">
<div class="col-md-12 ">
  <div class="sidemenu">
    <ul class="nav nav-pills1 flex-column">
      <li class="nav-item error-actions">
        <a id="ancReceiptAuthentication" class="nav-link" (click)="NavigateToScreen('receipt-authentication')"   >{{"SideMenu.ReceiptAuthenticationMenuItem" | translate}}</a>
      </li>
      <li  class="nav-item error-actions" [attr.disabled]=true>
        <a id="ancDownloadAuthentication" class="nav-link" (click)="NavigateToScreen('download-authenticated-receipt')" style="display: none;" >{{"SideMenu.DownloadAuthenticatedReceiptMenuItem" | translate}}</a>
      </li>
      <li  class="nav-item error-actions">
        <a id="ancDownloadLarge" class="nav-link" (click)="NavigateToScreen('receipts/retrieve')" >{{"SideMenu.DownloadLargeReceiptMenuItem" | translate}}</a>
      </li>
    </ul>
  </div>
    <!-- <hr class="d-sm-none"> -->
  </div>
</div>
</div>